import Reflux from 'reflux';
import EventData from 'shared/data/Event';

const async = { asyncResult: true },
  TagListActions = Reflux.createActions({
    enableEdit: {},
    cancelEdit: {},
    softDelete: async,
  });

TagListActions.softDelete.listenAndPromise(EventData.deleteGlobalElementLabel);

export default TagListActions;
